<template>
  <ModalWrapper
    modal-body-class="w-full p-6 mx-auto overflow-y-scroll overscroll-contain"
  >
    <ProductInventories :product-slug="props.productSlug" />
  </ModalWrapper>
</template>

<script setup>
const props = defineProps({
  productSlug: {
    type: String,
    required: true,
  },
});

const router = useRouter();

watch(
  router.currentRoute,
  (newValue, oldValue) => {
    this.$emit("close");
  },
  { deep: true }
);
</script>
